import { Button, Container, TextField, Typography } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import { UserContext } from "../context/UserContext";
import { useNavigate, Link, useLocation } from "react-router-dom";

const Login = () => {
  const { userState, dispatch } = useContext(UserContext); // Access user context to manage authentication state
  const [username, setUsername] = useState(""); // State for storing the username input
  const [password, setPassword] = useState(""); // State for storing the password input
  const [error, setError] = useState(""); // State for handling login error messages
  const navigate = useNavigate(); // Hook for programmatic navigation
  const location = useLocation(); // Hook to get current route location

  useEffect(() => {
    setError(""); // Reset error message when navigating to a different route
  }, [location.pathname]);

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    setError(""); // Clear any existing error messages

    const foundUser = JSON.parse(localStorage.getItem(username)); // Retrieve user data from localStorage

    if (foundUser !== null) {
      // Check if user exists in localStorage
      dispatch({
        type: "login", // Dispatch login action to update global state
        payload: foundUser,
      });
      localStorage.setItem("currentUser", JSON.stringify(foundUser)); // Store logged-in user in localStorage
      navigate("/"); // Redirect user to the home page
    } else {
      setError("User not found! Error username or password"); // Display error message if login fails
    }
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          width: "300px",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: "100px",
          margin: "auto",
          gap: "10px",
        }}
        onSubmit={handleSubmit} // Handle form submission when user clicks login
      >
        <TextField
          label="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)} // Update username state when input changes
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "gray",
                borderWidth: "2px",
              },
            },
          }}
        />

        <TextField
          label="password"
          type="password"
          value={password}
          sx={{
            width: "100%",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "gray",
                borderWidth: "2px",
              },
            },
          }}
          onChange={(e) => setPassword(e.target.value)} // Update password state when input changes
        />
        <Button type="submit" variant="contained" sx={{ width: "40%" }}>
          Log In
        </Button>
        <Typography
          sx={{
            textAlign: "center",
            color: "red",
            fontSize: "14px",
          }}
        >
          {error} {/* Display error message if login fails */}
        </Typography>
        <Typography
          sx={{
            fontSize: "15px",
            color: "white",
          }}
        >
          Don't have an account?{" "}
          <Link
            to="/signup" // Redirect to signup page if user doesn't have an account
            style={{
              textDecoration: "none",
              color: "#C9A227",
            }}
          >
            Sign Up
          </Link>
        </Typography>
      </form>
    </Container>
  );
};

export default Login; // Export Login component for use in the application
